
import { useDesignerStore } from "@/components/designer/store";
import { objectManager } from "@/components/designer/engine/ObjectManager";
import TextControls from "@/components/designer/panels/TextControls";

export default function StudioProperties() {
  const selectedObject = useDesignerStore(
    (state) => state.selectedObject
  );

  const isText = selectedObject?.type === "i-text";

  const width = useDesignerStore(
    (state) => state.selectedWidth
  );

  const height = useDesignerStore(
    (state) => state.selectedHeight
  );

  const rotation = selectedObject
    ? Math.round(selectedObject.angle ?? 0)
    : 0;

  const opacity = selectedObject
    ? Math.round((selectedObject.opacity ?? 1) * 100)
    : 100;

  return (
    <div className="rounded-2xl bg-[#141d2e] border border-slate-700 p-5">

      <h2 className="text-white text-2xl font-bold mb-6">
        Properties
      </h2>

      {!selectedObject ? (

        <div className="rounded-xl bg-slate-700 p-4 text-white">
          Nothing Selected
        </div>

      ) : (

        <div className="space-y-5">

          {/* Object */}

          <div className="rounded-xl bg-slate-700 p-4">

            <p className="text-xs uppercase tracking-wider text-slate-400">
              Selected Object
            </p>

            <p className="mt-2 text-xl font-bold text-white">
              {selectedObject.type === "i-text"
                ? "Text"
                : "Image"}
            </p>

          </div>

          {/* Text controls */}

          {isText && (
            <div className="rounded-xl bg-slate-700 p-4 space-y-3">
              <h3 className="text-white font-semibold">Edit text</h3>
              <TextControls />
            </div>
          )}

          {/* Size */}

          <div className="rounded-xl bg-slate-700 p-4">

            <h3 className="text-white font-semibold mb-4">
              Size
            </h3>

            <div className="flex justify-between">

              <div>

                <p className="text-slate-400 text-sm">
                  Width
                </p>

                <p className="text-cyan-400 text-2xl font-bold">
                  {width} cm
                </p>

              </div>

              <div>

                <p className="text-slate-400 text-sm">
                  Height
                </p>

                <p className="text-cyan-400 text-2xl font-bold">
                  {height} cm
                </p>

              </div>

            </div>

          </div>

          {/* Transform */}

          <div className="rounded-xl bg-slate-700 p-4">

            <h3 className="text-white font-semibold mb-4">
              Transform
            </h3>

            <div className="flex justify-between">

              <div>

                <p className="text-slate-400 text-sm">
                  Rotation
                </p>

                <p className="text-cyan-400 text-2xl font-bold">
                  {rotation}°
                </p>

              </div>

              <div>

                <p className="text-slate-400 text-sm">
                  Opacity
                </p>

                <p className="text-cyan-400 text-2xl font-bold">
                  {opacity}%
                </p>

              </div>

            </div>

          </div>

          {/* Actions */}

          <div className="rounded-xl bg-slate-700 p-4">

            <h3 className="text-white font-semibold mb-4">
              Actions
            </h3>

            <div className="space-y-3">

              <button
                onClick={() => objectManager.duplicateSelected()}
                className="w-full rounded-xl bg-cyan-600 hover:bg-cyan-500 py-3 font-semibold text-white transition"
              >
                📄 Duplicate
              </button>

              <button
                onClick={() => objectManager.bringForwardSelected()}
                className="w-full rounded-xl bg-slate-600 hover:bg-slate-500 py-3 font-semibold text-white transition"
              >
                ⬆ Bring Forward
              </button>

              <button
                onClick={() => objectManager.sendBackwardSelected()}
                className="w-full rounded-xl bg-slate-600 hover:bg-slate-500 py-3 font-semibold text-white transition"
              >
                ⬇ Send Backward
              </button>

              <button
                onClick={() => objectManager.deleteSelected()}
                className="w-full rounded-xl bg-red-600 hover:bg-red-500 py-3 font-semibold text-white transition"
              >
                🗑 Delete
              </button>

            </div>

          </div>

        </div>

      )}

    </div>
  );
}